import React from 'react';

import type { IGroupMember } from '@wix/social-groups-serverless/dist/members/types';

import { Box } from 'wui/Box';

import { ProfileListItem } from 'common/components/ProfileListItem';

import classes from './Thumbnail.scss';

export interface ThumbnailProps {
  createdBy: IGroupMember;
}

export function Thumbnail(props: ThumbnailProps) {
  return (
    <Box
      padding="SP3"
      width="100%"
      height="100%"
      flex={false}
      className={classes.root}
    >
      <ProfileListItem
        disablePadding
        subtitle={null}
        profile={props.createdBy}
        avatarProps={{ size: 'small' }}
      />
    </Box>
  );
}

Thumbnail.displayName = 'Thumbnail';
